/**
 * View component for /course-certificates/new
 *
 * Creates a new courseCertificate from a copy of the defaultItem in the courseCertificate reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as courseCertificateActions from '../courseCertificateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import courseCertificate components
import CourseCertificateForm from '../components/CourseCertificateForm.js.jsx';
import CourseCertificateLayout from '../components/CourseCertificateLayout.js.jsx';

class CreateCourseCertificate extends Base {
  constructor(props) {
    super(props);
    this.state = {
      courseCertificate: _.cloneDeep(this.props.defaultCourseCertificate)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {}
      /**
       * NOTE: formHelpers are useful for things like radio controls and other
       * things that manipulate the form, but don't directly effect the state of
       * the courseCertificate
       */
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(courseCertificateActions.sendCreateCourseCertificate(this.state.courseCertificate)).then((action) => {
      if(action.success) {
        dispatch(courseCertificateActions.invalidateList());
        history.push(`/course-certificates/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { courseCertificate, formHelpers } = this.state;
    const isEmpty = (courseCertificate.name === null || courseCertificate.name === undefined);
    return (
      <CourseCertificateLayout>
        <Helmet
          title={"Create Certificate | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <CourseCertificateForm
                courseCertificate={courseCertificate}
                cancelLink="/course-certificates"
                formHelpers={formHelpers}
                formTitle="Create Course Certificate"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </CourseCertificateLayout>
    )
  }
}

CreateCourseCertificate.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultCourseCertificate: store.courseCertificate.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateCourseCertificate)
);



// WEBPACK FOOTER //
// modules/courseCertificate/views/CreateCourseCertificate.js.jsx